/*
Model defined for Maintaining Branch Responses. It can also be used for transferring model
*/

export class BranchResponseModel {
    address: string;
    pickupLocation: boolean;
    email: string;
    id: string;
    latitude: string;
    longitude: string;
    name: string;
    mobile: string;
    branchType: string;
    partnerId: string;
    pinCode: string;
    city: string;
    state: string;
    branchStatus: string;
    branchCategory: string;
    wsflReferenceBranchId: string;
    gstNumber: string;
}
export class StateModel {
    id: string;
    stateName: string;
    stateType: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/branch/BranchResponseModel.ts